module.exports = __webpack_public_path__ + "static/media/img_about.b024aa25.jpg";